<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-layout v-if="client" row wrap>

                    <!-- Client Information -->
                    <v-flex xs6>
                        <v-toolbar color="primary" dark dense>
                            <v-icon>person</v-icon>
                            <span class="pl-3 subheading">Client Information</span>
                        </v-toolbar>

                        <v-tabs slider-color="grey" class="elevation-1" v-model="activeTab">
                            <v-tab ripple>Client Data</v-tab>
                            <v-tab ripple>Notes</v-tab>

                        <!-- Client Data -->
                        <v-tab-item>
                            <v-card class="pa-3 elevation-0">
                                <v-layout row wrap>
                                    <v-flex xs12 class="text-xs-left">
                                        <v-text-field label="Company Name" :value="client.merchantName" readonly></v-text-field>
                                    </v-flex>
                                    <v-flex xs4 class="text-xs-left">
                                        <v-text-field v-model="client.merchantCustomerId" readonly label="Customer ID"></v-text-field>
                                        <v-text-field v-model="client.email" label="Email Address" :rules="rules.email" required></v-text-field>
                                        <v-text-field v-model="client.street2" label="Street 2" ></v-text-field>
                                    </v-flex>
                                    <v-flex xs4 class="text-xs-left">
                                        <v-text-field v-model="client.firstName" label="First Name" :rules="rules.required" required></v-text-field>
                                        <v-text-field v-model="client.mobile" label="Mobile"></v-text-field>
                                        <v-text-field v-model="client.city" label="City" :rules="rules.required" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs4 class="text-xs-left">
                                        <v-text-field v-model="client.surname" label="Surname" :rules="rules.required" required></v-text-field>
                                        <v-text-field v-model="client.street1" label="Street 1" :rules="rules.required" required></v-text-field>
                                        <v-text-field v-model="client.postcode" label="Postcode" :rules="rules.required" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 class="text-xs-right">
                                        <v-btn :disabled="!client.merchantCustomerId ||
                                                        !client.email ||
                                                        !client.street2 ||
                                                        !client.firstName ||
                                                        !client.mobile ||
                                                        !client.city ||
                                                        !client.surname ||
                                                        !client.street1 ||
                                                        !client.postcode" class="mr-0 mb-0" @click="updateClient" color="primary">Update Client</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-tab-item>

                        <!-- Notes -->
                        <v-tab-item>
                            <v-card class="pa-3 elevation-0">
                                <v-layout row wrap>
                                    <v-flex xs12 pb-0 class="text-xs-left">
                                        <v-text-field v-model="note" label="Note"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 py-0 class="text-xs-right">
                                        <v-btn :disabled="!note" class="ma-0" @click="addNote" color="primary">Add Note</v-btn>
                                    </v-flex>
                                    <v-flex xs12 mt-3 class="text-xs-left">
                                        <v-data-table :headers="notesHeaders" :items="notes" :rows-per-page-items="[5]" class="elevation-1">
                                            <template slot="items" slot-scope="props">
                                                <td class="text-xs-left">{{ props.item.createdAt }}</td>
                                                <td class="text-xs-left">{{ props.item.username }}</td>
                                                <td class="text-xs-left">{{ props.item.note }}</td>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-tab-item>
                        </v-tabs>
                    </v-flex>

                    <!-- Registered Cards -->
                    <v-flex xs6>
                        <v-toolbar color="primary" dark dense>
                            <v-icon>credit_card</v-icon>
                            <span class="pl-3 subheading">Registered Cards</span>
                            <v-spacer></v-spacer>
                            <v-menu top origin="center center" transition="scale-transition">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-tile @click="registerCardDialog">
                                        <v-icon color="primary" class="pr-2">credit_card</v-icon>
                                        <v-list-tile-title @click.stop="regCardDialog = true">Register New Card</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                             </v-menu>
                        </v-toolbar>

                        <!-- Register Card Dialog -->
                        <v-dialog v-model="regCardDialog" max-width="500">
                            <v-toolbar color="primary" dark dense>
                                <v-icon>credit_card</v-icon>
                                <span class="pl-3 subheading">Register New Card</span>
                            </v-toolbar>
                            <v-card class="pa-3">
                                <v-layout row wrap>
                                    <v-flex xs12 class="text-xs-left" px-2>
                                        <v-text-field v-model="card.holder" label="Card Holder" :rules="rules.required" required></v-text-field> 
                                    </v-flex>
                                    <v-flex xs6 class="text-xs-left" px-2>
                                        <v-text-field v-model="card.address" label="First Line Address" :rules="rules.required" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 class="text-xs-left" px-2>
                                        <v-text-field v-model="card.postcode" label="Postcode" :rules="rules.required" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 class="text-xs-left" px-2>
                                        <v-text-field v-model="card.cardNumber" :mask="cardMask" label="Card Number" :rules="rules.required" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs4 class="text-xs-left" px-2>
                                        <v-text-field v-model="card.expMonth" mask="##" label="Exp Month" :rules="rules.required" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs4 class="text-xs-left" px-2>
                                        <v-text-field v-model="card.expYear" mask="##" label="Exp Year" :rules="rules.required" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs4 class="text-xs-left" px-2>
                                        <v-text-field v-model="card.cvv" mask="###" label="CVV" :rules="rules.required" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 class="text-xs-right">
                                        <v-btn class="mr-0" @click="regCardDialog = false" color="error">close</v-btn>
                                        <v-btn :disabled="!card.holder ||
                                                          !card.address ||
                                                          !card.postcode ||
                                                          !card.cardNumber ||
                                                          !card.expMonth ||
                                                          !card.expYear ||
                                                          !card.cvv" class="mr-0" @click="registerCard" color="primary">Register Card</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-dialog>

                        <!-- Take Payment Dialog -->
                        <v-dialog v-model="paymentDialog"  max-width="500">
                            <v-toolbar color="primary" dark dense>
                                <v-icon>event</v-icon>
                                <span class="pl-3 subheading">Take Payment</span>
                            </v-toolbar>
                            <v-card v-if="payment.registration" class="pa-3">
                                <v-layout row wrap>
                                    <v-flex xs12 my-2 class="subheading">Confirm a new transaction against a tokenised card.</v-flex>
                                    <v-flex my-2 v-if="payment.registration.paymentBrand == 'VISA'" xs3 class="visa payment-brand payment-brand-take-payment"></v-flex>
                                    <v-flex my-2 v-else-if="payment.registration.paymentBrand == 'MASTER'" xs2 class="mastercard payment-brand payment-brand-take-payment"></v-flex>
                                    <v-flex xs12 mt-2 mb-1><b>Card Number:</b> {{ payment.registration.bin }}******{{ payment.registration.last4Digits }}</v-flex>
                                    <v-flex xs12 my-1><b>Expire Date:</b> {{ payment.registration.expMonth }}/{{ payment.registration.expYear }}</v-flex>
                                    <v-flex xs12 my-1><b>Card Holder:</b> {{ payment.registration.holder }}</v-flex>
                                    <v-flex xs12 my-1><b>Added On:</b> {{ payment.registration.createdAt }}</v-flex>
                 
                                    <v-flex mt-4 xs6 offset-xs3>
                                        <v-select class="text-xs-left" v-model="payment.scheduleId" :items="schedules.options" item-text="scheduleName" item-value="id" dense label="Schedule ID"></v-select>
                                        <v-text-field prefix="£" v-model="payment.amount" label="Amount" type="number" :rules="rules.required" required></v-text-field>
                                    </v-flex>
                                        
                                    <v-flex xs12 mt-3 class="text-xs-right">
                                        <v-btn class="mr-0 mb-0" @click="paymentDialog = false" color="error">Close</v-btn>
                                        <v-btn :disabled="!payment.amount" class="mr-0 mb-0" @click="processPayment" color="primary">Submit</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-dialog>

                        <!-- Registered Cards -->
                        <v-card class="pa-3">
                            <v-switch v-model="archived" label="Archived" class="switch-14 pt-0" @change="getAllCards"></v-switch>

                            <v-data-table :headers="regCardHeaders" :items="cards" hide-actions class="elevation-1">
                                <template slot="items" slot-scope="props">
                                    <tr :class="props.item.status == 0 ? 'archived-row' : 'non-archived-row'">
                                        <td v-if="props.item.status == 1 && cardExpiry(props.item)" class="text-xs-center"><v-icon color="green">check_circle</v-icon></td>
                                        <td v-else-if="props.item.status == 1 && !cardExpiry(props.item)" class="text-xs-center"><v-icon color="red">error</v-icon></td>
                                        <td v-else-if="props.item.status == 0" class="text-xs-center"><v-icon color="primary">archive</v-icon></td>
                                        <td class="text-xs-left">
                                            <v-layout row wrap align-center>
                                                <v-flex v-if="props.item.paymentBrand == 'VISA'" xs3 class="visa payment-brand reg-card-visa"></v-flex>
                                                <v-flex v-else-if="props.item.paymentBrand == 'MASTER'" xs3 class="mastercard payment-brand reg-card-master"></v-flex>
                                                <v-flex xs9>{{ props.item.bin }}******{{ props.item.last4Digits }}</v-flex>
                                            </v-layout>
                                        </td>
                                        <td class="text-xs-left">{{ props.item.expMonth }}/{{ props.item.expYear }}</td>
                                        <td class="text-xs-left">{{ props.item.holder }}</td>
                                        <td class="text-xs-center">
                                            <v-menu top origin="center center" transition="scale-transition">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon v-on="on">
                                                        <v-icon>credit_card</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-tile @click="archiveCard(props.item.id)">
                                                        <v-icon class="pr-2">archive</v-icon>
                                                        <v-list-tile-title v-if="props.item.status == 1">Archive Card</v-list-tile-title>
                                                        <v-list-tile-title v-else>Unarchive Card</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                                <v-list v-if="props.item.status == 1 && cardExpiry(props.item)">
                                                    <v-list-tile @click.stop="createScheduleDialog = true; schedule.registrationId = props.item.id; schedule.registrationUuid = props.item.registrationId;">
                                                        <v-icon color="green" class="pr-2">event</v-icon>
                                                        <v-list-tile-title>Create Schedule</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                                <v-list v-if="props.item.status == 1 && cardExpiry(props.item)">
                                                    <v-list-tile @click="paymentDialog = true; payment.registration = props.item;">
                                                        <v-icon color="primary" class="pr-2">credit_card</v-icon>
                                                        <v-list-tile-title>Take Payment</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>

                            <!-- Create Schedule Dialog -->
                            <v-dialog v-model="createScheduleDialog" max-width="500">
                                <v-toolbar color="primary" dark dense>
                                    <v-icon>event</v-icon>
                                    <span class="pl-3 subheading">Create Schedule</span>
                                </v-toolbar>
                                <v-card class="pa-3">
                                    <v-layout row wrap>
                                        <v-flex xs6 px-2>
                                            <v-dialog ref="fromDateDialog" v-model="fromDateModal" :return-value.sync="schedule.fromDate" persistent lazy full-width width="290px">
                                                <v-text-field slot="activator" v-model="schedule.fromDate" label="From Date" append-icon="event" readonly></v-text-field>
                                                <v-date-picker v-model="schedule.fromDate" scrollable :first-day-of-week="1" :allowed-dates="allowedDates">
                                                    <v-spacer></v-spacer>
                                                    <v-btn flat color="primary" @click="fromDateModal = false">Cancel</v-btn>
                                                    <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                                                </v-date-picker>
                                            </v-dialog>
                                        </v-flex>
                                        <v-flex xs6 px-2>
                                            <v-dialog ref="toDateDialog" v-model="toDateModal" :return-value.sync="schedule.toDate" persistent lazy full-width width="290px">
                                                <v-text-field slot="activator" v-model="schedule.toDate" label="To Date" append-icon="event" readonly></v-text-field>
                                                <v-date-picker v-model="schedule.toDate" scrollable :first-day-of-week="1" :allowed-dates="allowedDates">
                                                    <v-spacer></v-spacer>
                                                    <v-btn flat color="primary" @click="toDateModal = false">Cancel</v-btn>
                                                    <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                                                </v-date-picker>
                                            </v-dialog>
                                        </v-flex>
                                        <v-flex xs6 px-2>
                                            <v-select v-model="schedule.paymentFrequency" :items="paymentFrequencyOptions" dense label="Payment Frequency" @change="schedule.collectionDay = null"></v-select>
                                        </v-flex>
                                        <v-flex v-if="schedule.paymentFrequency == 0" xs6 px-2>
                                            <v-select v-model="schedule.collectionDay" :items="collectionDayOptions" :rules="rules.required" return-object required dense label="Collection Day"></v-select>
                                        </v-flex>
                                        <v-flex v-else-if="schedule.paymentFrequency == 1" xs6 px-2>
                                            <v-select v-model="schedule.collectionDay" :items="collectionMonthVariableOptions" :rules="rules.required" return-object required dense label="Collection Day"></v-select>
                                        </v-flex>
                                        <v-flex v-else-if="schedule.paymentFrequency == 2" xs6 px-2>
                                            <v-select v-model="schedule.collectionDay" :items="collectionMonthSpecificOptions" :rules="rules.required" return-object required dense label="Collection Day"></v-select>
                                        </v-flex>
                                        <v-flex v-else-if="schedule.paymentFrequency == 3" xs6 px-2>
                                            <v-select v-model="schedule.collectionDay" :items="collectionSecondOptions" :rules="rules.required" return-object required dense label="Collection Day"></v-select>
                                        </v-flex>
                                        <v-flex v-else xs6 px-2></v-flex>
                                        <v-flex xs4 px-2>
                                            <v-text-field v-model="schedule.amount" prefix="£" label="Amount" :rules="rules.required" required></v-text-field>
                                        </v-flex>
                                        <v-flex xs4 mt-2 class="text-xs-right">
                                            <v-btn class="mr-0" @click="createScheduleDialog = false" color="error">Close</v-btn>
                                        </v-flex>
                                        <v-flex xs4 mt-2 class="text-xs-right">
                                            <v-btn :disabled="!schedule.collectionDay ||
                                                              !schedule.amount" @click="createSchedule" color="primary">Create Schedule</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-dialog>
                        </v-card>
                    </v-flex>

                    <!-- Schedules -->
                    <v-flex xs12>
                        <v-toolbar color="primary" dark dense>
                            <v-icon>event</v-icon>
                            <span class="pl-3 subheading">Schedules</span>
                        </v-toolbar>
                        <v-card class="pa-3">
                            <v-layout row wrap>
                                <v-flex xs2>
                                    <v-switch v-model="terminatedSchedules" label="Terminated Schedules" class="switch-14 pt-0" @change="scheduleSwitches('t')"></v-switch>
                                </v-flex>
                                <v-flex xs2>
                                    <v-switch v-model="activeSchedules" label="Active Schedules" class="switch-14 pt-0" @change="scheduleSwitches('f')"></v-switch>
                                </v-flex>
                            </v-layout>

                            <v-data-table id="table-schedules" :headers="scheduleHeaders" :items="schedules.view" hide-actions class="elevation-1">
                                <template slot="items" slot-scope="props">
                                    <tr :class="props.item.status == 0 || props.item.endDate < currentDate ? 'archived-row' : 'non-archived-row'">
                                        <td v-if="props.item.status == 1 && props.item.startDate < currentDate && props.item.endDate > currentDate" class="text-xs-center"><v-icon color="green">check_circle</v-icon></td>
                                        <td v-else-if="props.item.status == 1 && props.item.startDate > currentDate" class="text-xs-center"><v-icon color="blue">access_time</v-icon></td>
                                        <td v-else-if="props.item.status == 0 || props.item.endDate < currentDate" class="text-xs-center"><v-icon color="red">error</v-icon></td>
                                        
                                        <td class="text-xs-left"><b>#{{ props.item.id }}</b> - {{ props.item.frequency }} @ {{ props.item.collectionDay }}</td>
                                        <td class="text-xs-left">GBP {{ props.item.amount }}</td>
                                        <td class="text-xs-left">
                                            <v-layout row wrap align-center>
                                                <v-flex v-if="props.item.paymentBrand == 'VISA'" xs3 class="visa payment-brand reg-card-visa mx-0"></v-flex>
                                                <v-flex v-else-if="props.item.paymentBrand == 'MASTER'" xs3 class="mastercard payment-brand reg-card-master mx-0"></v-flex>
                                                <v-flex xs9>{{ props.item.bin }}******{{ props.item.last4Digits }}</v-flex>
                                            </v-layout>
                                        </td>
                                        <td class="text-xs-left">{{ props.item.startDate }}</td>
                                        <td class="text-xs-left">{{ props.item.endDate }}</td>
                                        <td class="text-xs-left">{{ props.item.previousExecution }}</td>

                                        <td v-if="!terminatedSchedules && props.item.endDate > currentDate" class="text-xs-left">{{ props.item.nextExecution }}</td>
                                        <td v-else-if="terminatedSchedules && props.item.cancelledAt" class="text-xs-left">{{ props.item.cancelledAt }}</td>
                                        <td v-else class="text-xs-left">{{ props.item.endDate }}</td>

                                        <td v-if="(!props.item.cancelledAt && props.item.status == 0) || (!props.item.cancelledAt && props.item.endDate < currentDate)" class="text-xs-center">
                                            SYSTEM
                                        </td>
                                        <td v-else-if="props.item.cancelledAt && props.item.status == 0" class="text-xs-center">
                                            {{ props.item.cancelledByName }}
                                        </td>

                                        <td class="text-xs-center">
                                            <v-menu top origin="center center" transition="scale-transition">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon v-on="on">
                                                        <v-icon>touch_app</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list v-if="activeSchedules">
                                                    <v-list-tile @click="deschedule(props.item)">
                                                        <v-icon color="error" class="pr-2">cancel</v-icon>
                                                        <v-list-tile-title>Deschedule</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                                <v-list>
                                                    <v-list-tile @click="getExecutionPlan(props.item)">
                                                        <v-icon color="primary" class="pr-2">assignment</v-icon>
                                                        <v-list-tile-title>Payment Summary</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                                <v-list>
                                                    <v-list-tile @click="sendSms(props.item)">
                                                        <v-icon color="green" class="pr-2">mdi-cellphone-message</v-icon>
                                                        <v-list-tile-title>Send SMS</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>

                    <!-- Execution Plan Dialog -->
                    <v-dialog v-model="executionPlanDialog" max-width="825">
                        <v-toolbar color="primary" dark dense>
                            <v-icon>event</v-icon>
                            <span class="pl-3 subheading">Payment Summary</span>
                        </v-toolbar>
                        <v-card class="pa-3">
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-data-table id="execution-plan-table" :headers="executionPlanHeaders" :items="executionPlan" :rows-per-page-items="[5]" class="elevation-1">
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-center">
                                            <v-chip v-if="props.item.source == 'OPENING'" color="grey" text-color="white" small>
                                                <v-avatar>
                                                    <v-icon>mdi-play-circle</v-icon>
                                                </v-avatar>
                                                OP
                                            </v-chip>
                                            <v-chip v-else-if="props.item.date < currentDate && props.item.status == 1 && props.item.source == 'SCHEDULER'" color="green" text-color="white" small>
                                                <v-avatar>
                                                    <v-icon>check_circle</v-icon>
                                                </v-avatar>
                                                {{ props.item.paymentType }}
                                            </v-chip>
                                            <v-chip v-else-if="props.item.source == 'MOTO' && props.item.status == 1" color="green" text-color="white" small>
                                                <v-avatar>
                                                    <v-icon>phone</v-icon>
                                                </v-avatar>
                                                {{ props.item.paymentType }}
                                            </v-chip>
                                            <v-chip v-else-if="props.item.source == 'MOTO' && props.item.status == 0" color="red" text-color="white" small>
                                                <v-avatar>
                                                    <v-icon>mdi-phone-off</v-icon>
                                                </v-avatar>
                                                {{ props.item.paymentType }}
                                            </v-chip>
                                            <v-chip v-else-if="props.item.date > currentDate" color="blue" text-color="white" small>
                                                <v-avatar>
                                                    <v-icon>access_time</v-icon>
                                                </v-avatar>
                                                PG
                                            </v-chip>
                                            <v-chip v-else color="red" text-color="white" small>
                                                <v-avatar>
                                                    <v-icon>error</v-icon>
                                                </v-avatar>
                                                {{ props.item.paymentType }}
                                            </v-chip>
                                        </td>

                                        <td v-if="props.item.increment" class="text-xs-left">SCHEDULER</td>
                                        <td v-else-if="props.item.source == 'MOTO'" class="text-xs-left">MOTO</td>
                                        <td v-else-if="props.item.source == 'OPENING'" class="text-xs-left"><b>OPEN</b></td>

                                        <td v-if="props.item.increment" class="text-xs-left">{{ props.item.increment }}</td>
                                        <td v-else class="text-xs-center"></td>
                                        
                                        <td class="text-xs-left">{{ props.item.date }}</td>

                                        <td v-if="props.item.source == 'OPENING'" class="text-xs-left"></td>
                                        <td v-else-if="props.item.amount" class="text-xs-left">GBP {{ props.item.amount }}</td>
                                        <td v-else class="text-xs-left"></td>

                                        <td v-if="props.item.processingTime" class="text-xs-left">GBP {{ props.item.balance }}</td>
                                        <td v-else-if="props.item.source == 'OPENING'" class="text-xs-left"><b>GBP {{ props.item.balance }}</b></td>
                                        <td v-else class="text-xs-left"></td>

                                        <td v-if="props.item.amount" class="text-xs-left"><b>GBP {{ props.item.arrears }}</b></td>
                                        <td v-else class="text-xs-left"></td>
                                    </template>
                                    </v-data-table>
                                </v-flex>
                                <v-flex xs12 mt-3 class="text-xs-right">
                                    <v-btn class="mr-0 mb-0" @click="executionPlanDialog = false" color="error">close</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-dialog>

                    <!-- Payment History -->
                    <v-flex xs12>
                        <v-toolbar color="primary" dark dense>
                            <v-icon>sync</v-icon>
                            <span class="pl-3 subheading">Payment History</span>
                        </v-toolbar>
                        <v-card class="pa-3">
                            <v-data-table :headers="paymentHeaders" :items="payments" hide-actions class="elevation-1">
                                <template slot="items" slot-scope="props">
                                    <td v-if="props.item.status == 1" class="text-xs-center">
                                        <v-chip v-if="props.item.source == 'SCHEDULER'" color="green" text-color="white" small>
                                            <v-avatar>
                                                <v-icon>check_circle</v-icon>
                                            </v-avatar>
                                            {{ props.item.paymentType }}
                                        </v-chip>
                                        <v-chip v-else color="green" text-color="white" small>
                                            <v-avatar>
                                                <v-icon>phone</v-icon>
                                            </v-avatar>
                                            {{ props.item.paymentType }}
                                        </v-chip>
                                    </td>
                                    <td v-else-if="props.item.status == 0" class="text-xs-center">
                                        <v-chip v-if="props.item.source == 'SCHEDULER'" color="red" text-color="white" small>
                                            <v-avatar>
                                                <v-icon>error</v-icon>
                                            </v-avatar>
                                            {{ props.item.paymentType }}
                                        </v-chip>
                                        <v-chip v-else color="red" text-color="white" small>
                                            <v-avatar>
                                                <v-icon>mdi-phone-off</v-icon>
                                            </v-avatar>
                                            {{ props.item.paymentType }}
                                        </v-chip>
                                    </td>
                                    <td class="text-xs-left">{{ props.item.processingTime }}</td>
                                    <td v-if="props.item.source == 'SCHEDULER' && props.item.scheduleId" class="text-xs-left"><b>#{{ props.item.scheduleId }}</b> - SCHEDULER</td>
                                    <td v-else-if="props.item.source == 'MOTO' && props.item.username && props.item.scheduleId" class="text-xs-left"><b>#{{ props.item.scheduleId }}</b> - MOTO - <span class="primary--text">{{ props.item.username }}</span></td>
                                    <td v-else-if="props.item.source == 'MOTO' && !props.item.username && props.item.scheduleId" class="text-xs-left"><b>#{{ props.item.scheduleId }}</b> - MOTO</td>
                                    <td v-else-if="props.item.source == 'MOTO' && props.item.username && !props.item.scheduleId" class="text-xs-left"><b>Standalone</b> - MOTO - <span class="primary--text">{{ props.item.username }}</span></td>
                                    <td class="text-xs-left">{{ props.item.resultDescription }}</td>
                                    <td class="text-xs-left">GBP {{ props.item.amount }}</td>
                                    <td class="text-xs-left">
                                        <v-layout row wrap align-center>
                                            <v-flex v-if="props.item.paymentBrand == 'VISA'" xs3 class="visa payment-brand reg-card-visa mx-0"></v-flex>
                                            <v-flex v-else-if="props.item.paymentBrand == 'MASTER'" xs3 class="mastercard payment-brand reg-card-master mx-0"></v-flex>
                                            <v-flex xs9>{{ props.item.bin }}******{{ props.item.last4Digits }}</v-flex>
                                        </v-layout>
                                    </td>
                                    <td class="text-xs-left">{{ props.item.holder }}</td>
                                    <td class="text-xs-center">
                                        <v-menu top middle :nudge-top="105" transition="scale-transition">
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon v-on="on">
                                                    <v-icon>touch_app</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list v-if="props.item.status == 1 && props.item.paymentType == 'DB'">
                                                <v-list-tile @click="processRefund(props.item)">
                                                    <v-icon color="primary" class="pr-2">cached</v-icon>
                                                    <v-list-tile-title>Refund</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
import axios from 'axios';
import sweetAlert from '../sweetAlert.js';
import moment from 'moment';

export default {
    data() {
        return {
            activeTab: null,
            client: null,
            payments: [],
            channels: { registrations: null, schedules: null },
            rules: { required: [ v => !!v || 'Required' ],
                     email: [ v => this.emailRule(v) ],
            },
            regCardHeaders: [{ text: 'Status', sortable: false, align: 'center' },
                             { text: 'Card Number', sortable: false, align: 'left' },
                             { text: 'Expiry Date', sortable: false, align: 'left' },
                             { text: 'Card Holder', sortable: false, align: 'left' },
                             { text: 'Action', sortable: false, align: 'center' }],
            scheduleHeaders: [{ text: 'Status', sortable: false, align: 'center' },
                              { text: 'Plan', sortable: false, align: 'left' },
                              { text: 'Amount', sortable: false, align: 'left' },
                              { text: 'Card Number', sortable: false, align: 'left' },
                              { text: 'Start Date', sortable: false, align: 'left' },
                              { text: 'End Date', sortable: false, align: 'left' },
                              { text: 'Previous Payment', sortable: false, align: 'left' },
                              { text: 'Next Payment', sortable: false, align: 'left' },
                              { text: 'Action', sortable: false, align: 'center' }],
            paymentHeaders: [{ text: 'Status', sortable: false, align: 'center' },
                              { text: 'Date', sortable: false, align: 'left' },
                              { text: 'Source', sortable: false, align: 'left' },
                              { text: 'Result', sortable: false, align: 'left' },
                              { text: 'Amount', sortable: false, align: 'left' },
                              { text: 'Card Number', sortable: false, align: 'left' },
                              { text: 'Card Holder', sortable: false, align: 'left' },
                              { text: 'Action', sortable: false, align: 'center' }],
            executionPlanHeaders: [{ text: 'Status', sortable: false, align: 'center' },
                                   { text: 'Source', sortable: false, align: 'left' },
                                   { text: '#', sortable: false, align: 'left' },
                                   { text: 'Payment Date', sortable: false, align: 'left' },
                                   { text: 'Amount', sortable: false, align: 'left' },
                                   { text: 'Outstanding Balance', sortable: false, align: 'left' },
                                   { text: 'Arrears', sortable: false, align: 'left' }],
            notesHeaders: [{ text: 'Timestamp', sortable: false, align: 'left', width: "25%" },
                           { text: 'Created By', sortable: false, align: 'left', width: "20%" },
                           { text: 'Note', sortable: false, align: 'left' }],
            cards: [],
            activeCards: [],
            archivedCards: [],
            schedules: { all: [], active: [], inactive: [], future: [], view: [], options: [] },
            executionPlan: [],
            regCardDialog: false,
            executionPlanDialog: false,
            createScheduleDialog: false,
            paymentDialog: false,
            card: { holder: null,
                    address: null,
                    postcode: null,
                    cardNumber: null,
                    expMonth: null,
                    expYear: null,
                    cvv: null },
            schedule: { fromDate: moment().add('1', 'day').format('YYYY-MM-DD').toString(),
                        toDate: moment().add('1', 'month').format('YYYY-MM-DD').toString(),
                        paymentFrequency: 0,
                        collectionDay: null,
                        registrationId: null,
                        registrationUuid: null,
                        holder: null,
                        cron: null,
                        amount: null,
                        frequency: null,
                        collectionDay: null,
                        collectionDayName: null
            },
            payment: { registration: null,
                       amount: null,
                       scheduleId: null },
            cardMask: 'credit-card',
            archived: false,
            fromDateModal: false,
            toDateModal: false,
            terminatedSchedules: false,
            activeSchedules: true,
            paymentFrequencyOptions: [{ text: 'Weekly', value: 0 },
                                      { text: 'Monthly - Variable', value: 1 },
                                      { text: 'Monthly - Specific', value: 2 }],
                                    //   { text: 'Seconds', value: 3 }],
            collectionDayOptions: [{ text: 'Monday', value: 'MON' },
                                   { text: 'Tuesday', value: 'TUE' },
                                   { text: 'Wednesday', value: 'WED' },
                                   { text: 'Thursday', value: 'THU' },
                                   { text: 'Friday', value: 'FRI' },
                                   { text: 'Saturday', value: 'SAT' },
                                   { text: 'Sunday', value: 'SUN' }],
            collectionMonthVariableOptions: [{ text: 'First Monday', value: '2#1' },
                                            { text: 'First Tuesday', value: '3#1' },
                                            { text: 'First Wednesday', value: '4#1' },
                                            { text: 'First Thursday', value: '5#1' },
                                            { text: 'First Friday', value: '6#1' },
                                            { text: 'First Saturday', value: '7#1' },
                                            { text: 'First Sunday', value: '1#1' },
                                            { text: 'Last Monday', value: '2L' },
                                            { text: 'Last Tuesday', value: '3L' },
                                            { text: 'Last Wednesday', value: '4L' },
                                            { text: 'Last Thursday', value: '5L' },
                                            { text: 'Last Friday', value: '6L' },
                                            { text: 'Last Saturday', value: '7L' },
                                            { text: 'Last Sunday', value: '1L' }],
            collectionMonthSpecificOptions: [{ text: '1st', value: 1 },
                                             { text: '2nd', value: 2 },
                                             { text: '3rd', value: 3 },
                                             { text: '4th', value: 4 },
                                             { text: '5th', value: 5 },
                                             { text: '6th', value: 6 },
                                             { text: '7th', value: 7 },
                                             { text: '8th', value: 8 },
                                             { text: '9th', value: 9 },
                                             { text: '10th', value: 10 },
                                             { text: '11th', value: 11 },
                                             { text: '12th', value: 12 },
                                             { text: '13th', value: 13 },
                                             { text: '14th', value: 14 },
                                             { text: '15th', value: 15 },
                                             { text: '16th', value: 16 },
                                             { text: '17th', value: 17 },
                                             { text: '18th', value: 18 },
                                             { text: '19th', value: 19 },
                                             { text: '20th', value: 20 },
                                             { text: '21st', value: 21 },
                                             { text: '22nd', value: 22 },
                                             { text: '23rd', value: 23 },
                                             { text: '24th', value: 24 },
                                             { text: '25th', value: 25 },
                                             { text: '26th', value: 26 },
                                             { text: '27th', value: 27 },
                                             { text: '28th', value: 28 },
                                             { text: '29th', value: 29 },
                                             { text: '30th', value: 30 },
            ],
            collectionSecondOptions: [{ text: '30 seconds', value: 30 }],
            note: null,
            notes: []
        }
    },
    beforeMount() {
       this.getClient();
       this.getPayments();
    },
    mixins: [ sweetAlert ],
    computed: {
        currentDate() {
            return moment().format('YYYY-MM-DD HH:mm:ss');
        }
    },
    methods: {
        getClient() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-client',
                data: { id: this.$route.params.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.client = response.data;
                    this.client.phone = `0${this.client.phone}`;
                    this.client.mobile = `0${this.client.mobile}`;
                    this.getMerchantChannels();
                    this.getCards();
                    this.getSchedules();
                    this.getNotes();
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        getMerchantChannels() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-merchant-channels',
                data: { merchantId: this.client.merchantId },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.channels.registrations = response.data.find(e => {
                        return e.registrations === 1;
                    });
                    this.channels.schedules = response.data.find(e => {
                        return e.type === 'SCHEDULER';
                    });

                    console.log(this.channels);
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        updateClient() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-update-client',
                data: { client: this.client },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    let result = { data: 'update-client-success' };
                    this.sweetAlert(result);
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        registerCard() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-register-card',
                data: { client: this.client, card: this.card, channel: this.channels.registrations, userId: localStorage.user_id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.sweetAlert(response.data);
                    this.getCards();

                    if(response.data.result.code == '000.000.000') {
                        this.regCardDialog = false;
                        Object.keys(this.card).forEach((key) => {
                            this.card[key] = null;
                        });
                    }
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        getCards() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-cards',
                data: { merchantId: this.client.merchantId, clientId: this.client.id, archived: this.archived },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.activeCards = response.data.filter(e => {
                        e.expMonth = e.expMonth < 10 ? `0${e.expMonth}` : e.expMonth;
                        return e.status === 1;
                    });

                    this.archivedCards = response.data.filter(e => {
                        return e;
                    });
                    this.cards = this.activeCards;

                    if(this.archived) {
                        this.cards = this.archivedCards;
                    }
                    else {
                        this.cards = this.activeCards;
                    }
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        getSchedules() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-schedules',
                data: { clientId: this.client.id},
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.schedules.all = response.data.filter(e => {
                        e.expMonth = e.expMonth < 10 ? `0${e.expMonth}` : e.expMonth;
                        return e;
                    });

                    this.schedules.inactive = this.schedules.all.filter(e => {
                        return e.status === 0 || e.endDate < this.currentDate;
                    });

                    this.schedules.active = this.schedules.all.filter(e => {
                        return e.status === 1 && e.endDate > this.currentDate;
                    });

                    this.schedules.options = this.schedules.all.filter(e => {
                        e.scheduleName = `Schedule #${e.id}`;
                        return e.status === 1;
                    });
                    this.schedules.options.unshift({ id: null, scheduleName: 'Standalone Payment'});
                    
                    this.schedules.view = this.schedules.active;
                    this.activeSchedules = true;
                    this.terminatedSchedules = false;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        getPayments() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-payments',
                data: { id: this.$route.params.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.payments = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        emailRule(v) {
            let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(typeof v !== 'undefined' && v)
            {   if(!pattern.test(v)) {
                    return 'Invalid Email address';
                }
                else { 
                    return true;
                }
            } 
            else {
                return true;
            }
        },
        getAllCards() {
            if(this.archived) {
                this.cards = this.archivedCards;
            }
            else {
                this.cards = this.activeCards;
            }
        },
        registerCardDialog() {

        },
        processPayment() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-payment',
                data: { payment: this.payment, channel: this.channels.registrations, userId: localStorage.user_id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(response);
                    this.sweetAlert(response.data);
                    setTimeout(() => {
                        this.getPayments();
                    }, 5000); 
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        processRefund(transaction) {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-refund',
                data: { transaction: transaction, userId: localStorage.user_id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.sweetAlert(response.data);
                    setTimeout(() => {
                        this.getPayments();
                    }, 5000); 
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        archiveCard(id) {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-archive-card',
                data: { id: id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.getCards();
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        createSchedule() {
            let executionPlan = [];
            let executionPlanJson = {};
            let temp = [];

            // Weekly
            if(this.schedule.paymentFrequency == 0) {
                let weeks = moment(moment(this.schedule.toDate)).diff(moment(this.schedule.fromDate), 'weeks');
                this.schedule.cron = `0 0 3 ? * ${this.schedule.collectionDay.value} *`;
                this.schedule.frequency = 'Weekly';

                let day = null;
                if(this.schedule.collectionDay.value == 'MON') { day = 1; }
                else if(this.schedule.collectionDay.value == 'TUE') { day = 2; }
                else if(this.schedule.collectionDay.value == 'WED') { day = 3; }
                else if(this.schedule.collectionDay.value == 'THU') { day = 4; }
                else if(this.schedule.collectionDay.value == 'FRI') { day = 5; }
                else if(this.schedule.collectionDay.value == 'SAT') { day = 6; }
                else if(this.schedule.collectionDay.value == 'SUN') { day = 7; }
          
                if(moment(this.schedule.fromDate).isoWeekday() <= day) { 
                    for(let i = 0; i < weeks; i++) {
                        executionPlan.push(moment(this.schedule.fromDate).isoWeekday(day).add(i, 'week').format('YYYY-MM-DD 03:00:00'));
                    }
                }
                else {
                    for(let i = 0; i < weeks; i++) {
                        executionPlan.push(moment(this.schedule.fromDate).add(1, 'weeks').isoWeekday(day).add(i, 'week').format('YYYY-MM-DD 03:00:00'));
                    }
                }
                console.log('Weekly');
            }
            // Monthly - Variable
            else if(this.schedule.paymentFrequency  == 1) {
                let months = moment(moment(this.schedule.toDate)).diff(moment(this.schedule.fromDate), 'months');
                this.schedule.cron = `0 0 3 ? * ${this.schedule.collectionDay.value}`;
                this.schedule.frequency = 'Monthly';

                // First instance of the month
                if(this.schedule.collectionDay.value.includes('#')) {
                    console.log("Start of month");

                    let day = this.schedule.collectionDay.value.charAt(0) - 1;
                    for(let i = 0; i <= months; i++) {                        
                        var date = moment(this.schedule.fromDate).add(i, 'month').startOf('month');
                        date = date.day(date.day() >= day ? day + 7 : day).format('YYYY-MM-DD 03:00:00');                        

                        if(date > moment().format('YYYY-MM-DD 03:00:00')) {
                            executionPlan.push(date);
                        }
                    }
                }
                // Last instance of the month
                else if(this.schedule.collectionDay.value.includes('L')) {
                    console.log("End of month - Variable");

                    for(let i = 0; i <= months; i++) {
                        let date = moment(this.schedule.fromDate).endOf('month').add(i, 'month').subtract(this.schedule.collectionDay.value.charAt(0) - 1, 'days').day(this.schedule.collectionDay.value.charAt(0) - 1).format('YYYY-MM-DD 03:00:00');
                        if(date > moment().format('YYYY-MM-DD 03:00:00')) {
                            executionPlan.push(date);
                        }
                    }
                }
            }
            // Monthly - Specific
            else if(this.schedule.paymentFrequency == 2) {
                this.schedule.cron = `0 0 3 ${this.schedule.collectionDay.value} * ? *`;
                let months = moment(moment(this.schedule.toDate)).diff(moment(this.schedule.fromDate), 'months');
                this.schedule.frequency = 'Monthly';

                for(let i = 0; i <= months; i++) {
                    if(this.schedule.collectionDay.value > 28 && moment(this.schedule.fromDate).add(i, 'month').format('M') == 2) {
                        executionPlan.push(moment().add(i, 'month').date(28).format('YYYY-MM-DD 03:00:00'));
                    }
                    else {
                        executionPlan.push(moment(this.schedule.fromDate).add(i, 'month').date(this.schedule.collectionDay.value).format('YYYY-MM-DD 03:00:00'));
                    }
                    
                }
                console.log("End of month - Specific");
            }
            // 30 Seconds - Testing Purposes
            else if(this.schedule.paymentFrequency == 3) {
                this.schedule.cron = `0/${this.schedule.collectionDay.value} * * ? * * *`;
                this.schedule.fromDate = moment().startOf('minute').add(2, 'minutes').subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss');
                this.schedule.toDate = moment().startOf('minute').add(6, 'minutes').subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss');
                this.schedule.frequency = 'Seconds';

                let inc = 0;
                for(let i = 0; i < 10; i++) {
                    executionPlan.push(moment(this.schedule.fromDate).add(inc, 'seconds').format('YYYY-MM-DD HH:mm:ss'));
                    inc = inc + 30;
                }
            }

            this.schedule.collectionDayName = this.schedule.collectionDay.text;
            executionPlan.forEach(function(v, k){
                executionPlanJson[k] = v;
            });
            
            console.log(this.schedule.fromDate);
            console.log(this.schedule.cron);
            console.log(executionPlanJson);

            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-create-schedule',
                data: { client: this.client, schedule: this.schedule, channel: this.channels.schedules, executionPlan: JSON.stringify(executionPlanJson), userId: localStorage.user_id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(response.data);
                    this.sweetAlert(response.data);
                    this.getSchedules();
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        deschedule(schedule) {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-deschedule',
                data: { channel: this.channels.schedules, scheduleId: schedule.scheduleId, userId: localStorage.user_id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(response.data);
                    this.sweetAlert(response.data);
                    this.getSchedules();
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        scheduleSwitches(schType) {

            if(schType == 't') {
                if(this.terminatedSchedules) {
                    this.activeSchedules = false;
                    this.schedules.view = this.schedules.inactive;
                    this.scheduleHeaders[7].text = 'Termination Date';
                    this.scheduleHeaders[8].text = 'Terminated By';
                    this.scheduleHeaders[9] = { text: 'Action', sortable: false, align: 'center' }
                }
                else {
                    this.activeSchedules = true;
                    this.schedules.view = this.schedules.active;
                    this.scheduleHeaders[7].text = 'Next Payment';
                    this.scheduleHeaders[8].text = 'Action';
                    this.scheduleHeaders.splice(9, 1); 
                }
            }
            else if(schType == 'f') {
                if(this.activeSchedules) {
                    this.terminatedSchedules = false;
                    this.schedules.view = this.schedules.active;
                    this.scheduleHeaders[7].text = 'Next Payment';
                    this.scheduleHeaders[8].text = 'Action';
                    this.scheduleHeaders.splice(9, 1);
                }
                else {
                    this.terminatedSchedules = true;
                    this.schedules.view = this.schedules.inactive;
                    this.scheduleHeaders[7].text = 'Termination Date';
                    this.scheduleHeaders[8].text = 'Terminated By';
                    this.scheduleHeaders[9] = { text: 'Action', sortable: false, align: 'center' }
                }
            }
        },
        getExecutionPlan(schedule) {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-execution-plan',
                data: { id: schedule.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.executionPlanDialog = true;
                    this.executionPlan = response.data;
                    
                    let openingBalance = response.data[0].status == 1 ? (parseFloat(response.data[0].balance) + parseFloat(response.data[0].amount)).toFixed(2) : parseFloat(response.data[0].balance).toFixed(2);
                    this.executionPlan.unshift({ amout: null, balance: openingBalance, date: null, increment: null, processingTime: null, source: 'OPENING', status: 1 });
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        sendSms(schedule) {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-send-sms',
                data: { schedule: schedule },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.executionPlanDialog = true;
                    this.executionPlan = response.data;
                    
                    let openingBalance = response.data[0].status == 1 ? (parseFloat(response.data[0].balance) + parseFloat(response.data[0].amount)).toFixed(2) : parseFloat(response.data[0].balance).toFixed(2);
                    this.executionPlan.unshift({ amout: null, balance: openingBalance, date: null, increment: null, processingTime: null, source: 'OPENING', status: 1 });
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        handleDateChange() {
            if(this.schedule.toDate < this.schedule.fromDate) {
                this.schedule.fromDate = this.schedule.toDate;
            }
            this.$refs.fromDateDialog.save(this.schedule.fromDate);
            this.$refs.toDateDialog.save(this.schedule.toDate);
        },
        allowedDates: val => val >= moment().add('1', 'day').format('YYYY-MM-DD'),
        cardExpiry(card) {
            let exp = `${card.expYear}-${card.expMonth}-01`;
           return moment(exp) > moment(this.currentDate);
        },
        addNote() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-add-note',
                data: { note: this.note, clientId: this.client.id, userId: localStorage.user_id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.getNotes();
                    this.note = null;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        getNotes() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-notes',
                data: { clientId: this.client.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.notes = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        }
    }
}
</script>

<style>
    .reg-card-visa {
        background-size: 80%;
    }

    .reg-card-master {
        background-size: 70%;
    }

    .switch-14 label {
        font-size: 14px;
    }

    .archived-row {
        background: #eee;
    }

    #execution-plan-table td {
        height: 40px;
    }

    .v-icon {
        vertical-align: middle !important;
    }

    .payment-brand-take-payment {
        height: 62px;
    }

    #table-schedules .theme--light.v-table thead tr:first-child {
        border-bottom: 1px solid #ccc;
    }
</style>